import { render, staticRenderFns } from "./ProcesionesView.vue?vue&type=template&id=b1f720aa&scoped=true"
import script from "./ProcesionesView.vue?vue&type=script&lang=js"
export * from "./ProcesionesView.vue?vue&type=script&lang=js"
import style0 from "./ProcesionesView.vue?vue&type=style&index=0&id=b1f720aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f720aa",
  null
  
)

export default component.exports